export interface PaymentTariff {
  id?: string;
  name?: string;
  months: number;
  price: number;
  per_month: number;
  autopayment_enabled?: boolean | null;
}

export type PaymentTariffsResponse = PaymentTariff[];

// Enum для методов оплаты согласно серверной валидации
export enum PaymentMethodCode {
  YOOKASSA = "YOOKASSA",
  TBANK = "TBANK",
  BALANCE = "BALANCE",
}

// Типы для методов оплаты
export interface PaymentMethod {
  id: string;
  name: string;
  type?: string;
  alias?: string; // Альтернативное название для отображения
  method_code?: PaymentMethodCode; // Код метода для API (YOOKASSA, TBANK, BALANCE)
  is_active: boolean;
  is_priority: boolean;
  requires_email: boolean;
}

export interface PaymentMethodsResponse {
  methods: PaymentMethod[];
}

export interface GetPaymentMethodsRequest {
  months: number;
  autopayment_enabled: boolean;
  subscription_id?: string | null;
}

// Типы для создания счета на оплату согласно API (GetPriceItem + CreateBillRequest)
export interface CreateBillRequest {
  subscription_id?: string; // ID текущей подписки для продления (необязательно при покупке новой)
  months: number; // Период в календарных месяцах (1, 3, 6, 12, 24, 48)
  server?: number; // ID сервера (обязателен только при покупке новой подписки, не при продлении)
  method: PaymentMethodCode | string; // Метод оплаты (YOOKASSA, TBANK, BALANCE)
  autopayment_enabled: boolean;
}

export interface CreateBillBalanceResponse {
  success: true;
  bill_id?: string;
}

export interface CreateBillPaymentResponse {
  url?: string | null;
  bill_id?: string;
}

export type CreateBillResponse =
  | CreateBillBalanceResponse
  | CreateBillPaymentResponse;

// Типы для проверки статуса оплаты
export interface BillStatusResponse {
  paid: boolean;
}

// Типы для истории транзакций
export interface BillHistoryItem {
  bill_id: string;
  status: string;
  timestamp: string;
  amount: number;
  bill_initiator: string;
  description: string;
}

export interface BillsHistoryResponse {
  history?: BillHistoryItem[];
  autopayment: boolean;
  next_auto_pay_date?: string | null;
  autopay_amount?: number | null;
}

// Типы для ошибок API
export interface PaymentApiError {
  detail: string;
}

export interface PaymentValidationError {
  detail: Array<{
    loc: (string | number)[];
    msg: string;
    type: string;
  }>;
}

export interface SetEmailRequest {
  email: string;
}

export interface SetEmailResponse {
  success: boolean;
  message: string;
}
